import React, { createContext, useContext, useMemo } from 'react';
import { UserLookupContext } from './UserLookupContext';
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const SpaceContext = createContext(undefined);
/**
 * use instead of React.useContext
 */
export function useSpaceContext() {
    const spaceContext = useContext(SpaceContext);
    return useMemo(() => spaceContext ?? {}, [spaceContext]);
}
export function SpaceContextProvider(props) {
    const { spaceId, children } = props;
    return (React.createElement(SpaceContext.Provider, { value: { spaceId } },
        React.createElement(UserLookupContext.Provider, { value: { spaceId } }, children)));
}
//# sourceMappingURL=SpaceContextProvider.js.map